
import React, { memo } from 'react'

import DefaultLayout from '~layouts/DefaultLayout'
import { HelmetProvider } from 'react-helmet-async'

import { MicrocopyProvider } from '~contexts/MicrocopyContext'
import { SessionProvider } from '~contexts/SessionContext'
import { CookiesProvider } from 'react-cookie'

import Head from './Head'
import Header from '~components/Header'

import style from './FramedLayout.module.scss'

const FramedLayout = ({
  children,
  showHeader,
  showSearch,
  microcopy
}) => (
  <DefaultLayout>
    <HelmetProvider>
      <CookiesProvider>
        <SessionProvider>
          <Head microcopy={microcopy} />
          <MicrocopyProvider microcopy={microcopy}>
            { showHeader && <Header showSearch={showSearch} /> }
            <div className={style.frame} id='scroll-body'>{ children }</div>
          </MicrocopyProvider>
        </SessionProvider>
      </CookiesProvider>
    </HelmetProvider>
  </DefaultLayout>
)

export default memo(FramedLayout)